<template>
	<div class="flex justify-center p-6 md:p-12" v-if="isOld">
		<blockquote class="flex flex-1 bg-gray-50 w-full xl:max-w-xl border-l-4 border-orange-500">
			<div class="relative top-0 left-0 mt-4 -ml-10 ">
				<div id="icon" class="flex items-center justify-center bg-orange-500 w-8 h-8 rounded-full text-white">
					<svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
						stroke="currentColor" class="h-7 w-7">
						<path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
					</svg>
				</div>
			</div>
			<div id="content" class="flex py-4 pl-4 pr-6">
				<p class="text-sm md:text-base">
					This post is over a year old, some of the information may be outdated now, please check if there are
					updates.
				</p>
			</div>
		</blockquote>
	</div>

</template>

<script>
	export default {
		props: {
			publishedDate: null,
		},
		methods: {
			postDateOlder() {
				const current = new Date();
				var yearAgo = new Date().setFullYear(current.getFullYear() - 1);

				var posted = (new Date(1970, 0, 1)).setSeconds(this.publishedDate);

				return posted - yearAgo < 0;
			}
		},
		computed: {
			isOld() {
				return this.publishedDate ?
					this.postDateOlder() :
					false;
			}
		},
	}

</script>

<style>

</style>
